import { GET_MARKET_SHARE, GET_ALL_COMPASS, GET_ALL_COMPASS_TABLE, GET_ALL_STATES } from './types'

const initialState = {
  marketShare: [],
  compassData: [],
  compassDataTable: [],
  statesData: [],
}

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_MARKET_SHARE:
      return {
        ...state,
        marketShare: action.payload,
      }
    case GET_ALL_COMPASS_TABLE:
      return {
        ...state,
        compassDataTable: action.payload,
      }
    case GET_ALL_COMPASS:
      return {
        ...state,
        compassData: action.payload,
      }
    case GET_ALL_STATES:
      return {
        ...state,
        statesData: action.payload,
      }
    default:
      return state
  }
}
